<template>
  <div class="upload-queue">
    <div class="results-holder">
      <div class="image-cancel-box">
        <div class="image-box" v-if="selections.length > 1">
          <div v-for="image in selections" :key="image" class="image-container">
            <img class="img" :src="getFileType(image.imageUri, image.file)">
          </div>
        </div>
      </div>

      <div class="upload-image-holder" v-if="selections.length === 1">
        <div class="upload-image-placeholder">
          <img class="img" :src="getFileType(selected.imageUri, selected.file)">
          <div class="upload-image-text">
            <p>{{ selected.file }}</p>
            <p>{{ selected.type }}</p>
            <p>{{ selected.size }}</p>
          </div>
        </div>

      </div>
      <!--      <SearchMenu />-->
      <SelectionOptions />
      <div class="keywords-label">
        UPLOAD QUEUE
      </div>
      <SearchResults type="uploads" />
    </div>
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';
import SearchMenu from '@/components/libraries/search/SearchMenu';
import SearchResults from '@/components/libraries/SearchResults';
import { mapStores } from 'pinia';
import {useModalStore} from '@/store/ModalStore';
import SelectionOptions from '@/components/libraries/search/SelectionOptions';
export default {
  name: 'UploadQueue',
  components: {
    SearchMenu,
    SearchResults,
    SelectionOptions
  },
  setup () {
    const RMTStore = useRMTStore();
    const modalStore = useModalStore();
    return {
      RMTStore, modalStore
    };
  },
  computed: {
    ...mapStores(useRMTStore, useModalStore),
    selected () {
      return this.RMTStore.getSelectedUploadedFileData;
      // return this.RMTStore.selectedUploads;
    },
    selections () {
      return this.RMTStore.selectedUploads;
    },
    selectedItemNum () {
      // todo this may need to be a direct reference and not a getter
      return this.RMTStore.getSelectedItemNum;
    },
    getUploadMode () {
      return this.RMTStore.inUploadMode;
    }
  },
  methods: {
    getFileType (uri, fileName) {
      let type = fileName.substr(fileName.lastIndexOf('.') + 1);
      type = type.toLowerCase();
      let file;
      switch (type) {
         case 'pdf':
            file = 'https://nelsonirrigation.com/images/thumbnails/pdf.png';
            break;
         case 'psd':
            file = 'https://nelsonirrigation.com/images/thumbnails/psd.png';
            break;
         case 'dwg': 
            file = 'https://nelsonirrigation.com/images/thumbnails/dwg.png';
            break;
         default:
            file = uri;
            break;
      }
      return file;
    },
    
    handleCancelPrompt () {
      this.modalStore.setModalObj({
        promptLabel: 'REMOVE TAG',
        promptDescription: 'Are you sure you want to return to the library?',
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.confirmReturnToLibrary,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelRemove
      });
      this.modalStore.showModal('prompt');
    },
    confirmReturnToLibrary () {
      this.RMTStore.uploadCancel();
      this.cancelRemove();
    },
    cancelRemove () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>
.image-box {
  display: grid;
  grid-template-columns: auto auto auto auto;
  padding: 10px;
  border: 1px solid black;
  overflow-y: auto;
  max-height: 200px;
  margin: 1rem;
}
.image-container {
  height: 100px;
  padding: 10px 2px;
  margin-bottom: 5px;
  margin-left: 2px;
  margin-right: 2px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  border: 1px solid white;
}
.upload-queue {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.icon-size-del {
  width: 14px;
}
.image-cancel-box {
  display: grid;
  grid-template-columns: auto;
  width: 100%;
}
.close-btn {
  justify-self: end;
}
.close-btn2 {
  align-self: flex-end;
}
.close-btn,
.close-btn2 {
  justify-self: end;
  cursor: pointer;
  width: 35px;
  height: 35px;
  border-radius: 30px;
  background-color: lightgrey;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-image-text {
  width: 200px;
  padding-left: 1rem;
  align-self: flex-end;
}
.results-container, .results-holder {
  margin-top: 5px;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}
.upload-image-holder {
  display: grid;
  grid-template-columns: auto auto;
  width: 100%;
  height: 200px;
  margin-bottom: 3rem;
}
.upload-image-placeholder {
  display: grid;
  grid-template-columns: 200px auto auto;
  margin: 1rem 0 2rem 0;
  margin-bottom: 20px;
  width: 200px;
  height: 200px;
  background-color: lightgray;
}
.img {
  border: 1px solid black;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>